export const DEFAULT_ACADEMY_ROUTE = 'academy';
export const DEFAULT_ACADEMY_ARTICLE_ROUTE = 'academy-articleSlug';

export const DEFAULT_ACADEMY_TOPIC = {
  topic: 'All articles',
  slug: 'all-articles',
};
